import { Box } from '@mui/material';

export default function PaymentOptionImageContainer() {
  const logos = [
    { src: '/static/images/credit-cards/candid-visa.png', alt: 'Credit Card' },
    { src: '/static/images/credit-cards/candid-mastercard.png', alt: 'ACH' },
    { src: '/static/images/credit-cards/candid-discover.png', alt: 'ACH' },
    { src: '/static/images/credit-cards/candid-amex.png', alt: 'ACH' },
    { src: '/static/images/credit-cards/candid-ach.png', alt: 'ACH' },
  ];
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        justifyContent: 'start',
      }}
    >
      {logos.map((logo, index) => (
        <Box
          key={index}
          sx={{
            width: 90,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <Box
            component="img"
            src={logo.src}
            alt={logo.alt}
            sx={{
              width: 85,
              height: 60,
              objectFit: 'contain',
            }}
          />
        </Box>
      ))}
    </Box>
  );
}
